<template>
  <b-card
    no-body
    class="card-developer-meetup"
  >
    <b-card-body>
      <!-- metting header -->
      <div class="meetup-header d-flex align-items-center">
        <div class="meetup-day">
          <h6 class="mb-0">
            {{ localDataDay }}
          </h6>
          <h3 class="mb-0">
            {{ localDataDate }}
          </h3>
        </div>
        <div class="my-auto">
          <b-card-title class="mb-25">
            {{ dataMeetup.keterangan }}
          </b-card-title>
          <!-- <b-card-text class="mb-0">

          </b-card-text> -->
        </div>
      </div>
      <!--/ metting header -->

      <b-badge
        v-if="isExist(dataMeetup)"
        class="mb-2"
        variant="primary"
      >
        Saya ada PIC tiket ini.
      </b-badge>

      <!-- media -->
      <b-media
        v-for="media in mediaData"
        :key="media.avatar"
        no-body
      >
        <b-media-aside class="mr-1">
          <b-avatar
            rounded
            variant="light-primary"
            size="34"
          >
            <feather-icon
              :icon="media.avatar"
              size="18"
            />
          </b-avatar>
        </b-media-aside>
        <b-media-body>
          <h6 class="mb-0">
            {{ media.title }}
          </h6>
          <small>{{ media.subtitle }}</small>
        </b-media-body>
      </b-media>

      <!-- avatar group -->
      <b-avatar-group
        class="mt-2 pt-50"
        size="33"
      >
        <b-avatar
          v-for="avatar in dataMeetup.user_tiket_all"
          :key="avatar.avatar"
          v-b-tooltip.hover.bottom="avatar.name"
          :src="avatar.avatar"
          :to="{ name: 'pages-profile-detail', params: {id: avatar.user_id}}"
          class="pull-up"
        />
        <!-- <h6 class="align-self-center cursor-pointer ml-1 mb-0" v-if="dataMeetup.total">
          +{{ dataMeetup.total }}
        </h6> -->
      </b-avatar-group>
      <hr>
      <div class="d-flex justify-content-between align-items-center">
        <!-- <b-link
          :to="{ name: 'pages-tiket-detail', params: { id: dataMeetup.id } }"
          class="font-weight-bold"
        >
          Lihat Selengkapnya
        </b-link> -->
        <b-button
          variant="primary"
          v-if="$can('proses', 'tiket') && canUpdate(dataMeetup) && dataMeetup.is_draft === 0 && canProses(userData,dataMeetup)"
          :adminProcess="true"
          :to="{ name: 'pages-tiket-ubah', params: { id: dataMeetup.id } }"
        >
          <feather-icon
            icon="CheckCircleIcon"
          />
          Proses
        </b-button>

        <!-- <b-button
          variant="primary"
          v-else-if="!$can('proses', 'tiket') && dataMeetup.is_draft === 0 && userData.id !== dataMeetup.user_id"
          :to="{ name: 'pages-tiket-ubah', params: { id: dataMeetup.id } }"
        >
          <feather-icon
            icon="CheckCircleIcon"
          />
          Prosesaa
        </b-button> -->
        <!-- <b-button
          variant="primary"
          v-else-if="!$can('proses', 'tiket') && canUpdate(dataMeetup) && dataMeetup.status_tiket.nama !== 'Selesai'"
          :to="{ name: 'pages-tiket-ubah', params: { id: dataMeetup.id } }"
        >
          <feather-icon
            icon="EditIcon"
          />
          Ubah
        </b-button> -->
        <!-- v-else-if="dataMeetup.is_draft === 1 && dataMeetup.status_tiket.nama !== 'Selesai'" -->
        <b-button
          variant="primary"
          v-else-if="($can('proses', 'tiket') || !$can('proses', 'tiket')) && dataMeetup.is_draft === 1"
          :to="{ name: 'pages-tiket-ubah', params: { id: dataMeetup.id } }"
        >
          <feather-icon
            icon="EditIcon"
          />
          Ubah
        </b-button>
        <!-- <b-button
          variant="primary"
          v-else-if="!$can('proses', 'tiket') && dataMeetup.is_draft === 1"
          :to="{ name: 'pages-tiket-ubah', params: { id: dataMeetup.id } }"
        >
          <feather-icon
            icon="EditIcon"
          />
          Ubah
        </b-button> -->
        <b-button
          variant="primary"
          v-else-if="$can('assign', 'tiket') && dataMeetup.user_tiket_all.length >= 2 && canStatusApproval(dataMeetup.user_tiket)"
          @click="approve(dataMeetup.user_tiket[0].id)"
        >
          <feather-icon
            icon="EditIcon"
          />
          Approve
        </b-button>

        <b-button
          variant="primary"
          v-if="$can('assign', 'tiket') && dataMeetup.user_tiket_all.length >= 2 && canStatusApproval(dataMeetup.user_tiket)"
          @click="tolak(dataMeetup.user_tiket[0].id)"
        >
          <feather-icon
            icon="EditIcon"
          />
          Tolak
        </b-button>
        <b-button
          variant="primary"
          :to="{ name: 'pages-tiket-lihat', params: { id: dataMeetup.id } }"
        >
          <feather-icon
            icon="ZoomInIcon"
          />
          Lihat
        </b-button>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BImg, BCardBody, BCardText, BBadge, BCardTitle, BMedia, BMediaAside, BAvatar, BAvatarGroup, VBTooltip, BMediaBody,
  BLink, BButton,
} from 'bootstrap-vue'
import moment from 'moment'
import {
  approve,
  tolak,
} from '@/connection-api/tiket'
/* eslint-disable global-require */
export default {
  components: {
    BCard,
    BCardBody,
    // BCardText,
    BCardTitle,
    BMedia,
    BMediaAside,
    BAvatar,
    BAvatarGroup,
    BMediaBody,
    // BLink,
    BBadge,
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  // props: ['dataMeetup', 'onlyView'],
  data() {
    return {
      localDataDay: this.dataMeetup.day, // moment(this.dataMeetup.tanggal_mulai).format('ddd'),
      localDataDate: moment(this.dataMeetup.tanggal_mulai).format('DD'),
      mediaData: [
        { avatar: 'CalendarIcon', title: this.dataMeetup.tanggal, subtitle: '' },
        { avatar: 'MapPinIcon', title: ((this.dataMeetup.wilayah) ? this.dataMeetup.wilayah.URAIAN : 'Sekretariat/Direktorat'), subtitle: ((this.dataMeetup.upt) ? this.dataMeetup.upt.URAIAN : this.dataMeetup.struktur_organisasi.nama) },
        { avatar: 'ChecklistIcon', title: 'Status', subtitle: ((this.dataMeetup.status_tiket) ? this.dataMeetup.status_tiket.nama : 'Draft') },
        { avatar: 'ActivityIcon', title: this.dataMeetup.select_kategori_jenis_tiket.nama, subtitle: this.dataMeetup.select_jenis_tiket.nama },
      ],
      /* eslint-disable global-require */
      defaultImage: require('@/assets/images/avatars/default.png'),
      /* eslint-disable global-require */
      avatars: [],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  methods: {
    async approve(id) {
      try {
        const response = await approve(id)
        this.makeToast('success', 'Tiket Berhasil Di Approve!')
        window.location.reload()
      } catch (error) {
        this.makeToast('danger', error.response.data.data)
        this.show = false
      }
    },
    async tolak(id) {
      try {
        const response = await tolak(id)
        this.makeToast('success', 'Tiket Berhasil Di Tolak!')
        window.location.reload()
      } catch (error) {
        this.makeToast('danger', error.response.data.data)
        this.show = false
      }
    },
    makeToast(variant = null, message = null) {
      this.$bvToast.toast(message, {
        title: 'Tiket',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
    isExist(data) {
      if (this.onlyView === true) {
        return false
      }
      if (data.user_tiket_all.length > 0 && data.user_tiket && data.user_tiket[0] && data.user_tiket[0].status_approval_id === '24a99fbd-2545-11ee-acb1-3497f616fa2') {
        return true
      }
      return false
    },
    canUpdate(data) {
    //   console.log('aaa')
    // console.log(this.userData)
      if (this.$can('manage', 'all')) {
        return true
      }
      if (data.is_draft === 0 && this.$can('update', 'tiket')) {
        return true
      }
      if (data.is_draft === 0 && this.$can('proses', 'tiket')) {
        return true
      }
      if (data.user_tiket_all.length > 0 && this.$can('update', 'tiket')) {
        return false
      }
      if (data.user_id === this.userData.id && this.$can('update', 'tiket')) {
        return true
      }
      if (data.user_tiket_all.length === 0 && this.$can('update', 'tiket')) {
        return true
      }
      if (data.user_tiket && data.user_tiket[0] && this.$can('update', 'tiket') && data.user_tiket[0].status_approval_id === '24a99fbd-2545-11ee-acb1-3497f616fa2') {
        return true
      }
      return false
    },
    canProses(dataUser, data) {
      const findUser = this.findUser(data.user_tiket_all, dataUser.id)
      if (dataUser.roles.indexOf('superadmin') !== -1 && this.dataMeetup.user_tiket_all.length < 2) {
        return true
      } if (dataUser.roles.indexOf('admin') !== -1 && this.dataMeetup.user_tiket_all.length < 2) {
        return true
      } if (dataUser.roles.indexOf('ditjenpas') !== -1 && dataUser.id !== data.user_id && this.dataMeetup.user_tiket_all.length < 2) {
        return true
      } if (dataUser.roles.indexOf('ditjenpas') !== -1 && findUser && this.dataMeetup.user_tiket_all.length === 3) {
        return true
      } if (dataUser.roles.indexOf('helpdesk') !== -1 && dataUser.id !== data.user_id && this.dataMeetup.user_tiket_all.length < 2) {
        return true
      } if (dataUser.roles.indexOf('helpdesk') !== -1 && findUser && this.dataMeetup.user_tiket_all.length === 3) {
        // console.log(dataUser)
        // console.log(data.user_tiket_all)
        // console.log(data.user_tiket_all.isArray('914'))
        return true
      }
      // else if(dataUser.roles.indexOf("supervisor") !== -1 && dataUser.id !== data.user_id && this.dataMeetup.user_tiket_all.length < 1)
      // {
      //   return true
      // }
      // else if(dataUser.roles.indexOf("ditjenpas") !== -1 && dataUser.id !== data.user_id && this.dataMeetup.user_tiket_all.length == 2 && data.user_tiket[0].status_approval_id === 2)
      // {
      //   return true
      // }
      return false
    },

    findUser(datas, userId) {
      let returnFindUser = false
      let totalApproval = 0
      let countData = datas.length
      const coba = datas.forEach(data => {
        if (data.status_approval_id !== '24a99fbd-2545-11ee-acb1-3497f616fa5') {
          totalApproval += 1
        }
        countData -= 1
        if (data.user_id === userId && data.jenis_user_id !== null && data.status_approval_id === '24a99fbd-2545-11ee-acb1-3497f616fa2') {
          returnFindUser = true
        } if (data.user_id === userId && data.jenis_user_id === null && data.status_approval_id === '24a99fbd-2545-11ee-acb1-3497f616fa2'
          && totalApproval === 1) {
          returnFindUser = true
        }
      })
      return returnFindUser
    },
    canStatusApproval(data) {
      if (data.length > 0 && data[0].status_approval_id === '24a99fbd-2545-11ee-acb1-3497f616fa2' && this.userData.roles.indexOf('supervisor') !== -1 && this.userData.id === data[0].user_id
        && this.dataMeetup.user_tiket_all.length === 3) {
        return true
      }
      // else if(data.length > 0 && data[0].status_approval_id === 2 && this.userData.roles.indexOf("supervisor") === -1 && this.userData.id === data[0].user_id
      // && this.dataMeetup.user_tiket_all.length == 2)
      // {
      //   return true
      // }
      return false
    },
  },
}
</script>
